// Tiptap节点类型映射到Outline节点类型
import { PaperOutline } from "../types/Writer/OutlineNode.ts";

// Tiptap节点类型映射到Outline节点类型
export const NODE_TYPE_MAPPING = {
  paragraph: "paragraph",
  heading: "section",
  bulletList: "ul",
  orderedList: "ol",
  listItem: "li",
  blockquote: "paragraph",
  codeBlock: "code",
  horizontalRule: "paragraph",
  figure: "figure",
  image: "figure",
  comment: "comment",
  table: "table",
  tableRow: "table",
  tableCell: "table",
  tableHeader: "table",
  hardBreak: "paragraph",
  footnote: "footnote",
  equation: "equation",
  blockEquation: "equation",
  reference: "reference",
  refer: "reference",
  imgCode: 'imgCode'
};
// Tiptap元素标记类型映射
export const MARK_TYPE_MAPPING = {
  bold: "strong",
  italic: "em",
  underline: "u",
  strike: "s",
  link: "a",
  code: "code",
};
// tiptap块级level都是2，但是outline并不都是 。。
export const BLOCK_ELEMENT = [
  "bulletList",
  "orderedList",
  "blockEquation",
  "codeBlock",
  "table",
];

// latex转换
// 提取处理label的公共函数
export const processLabelWithNumber = (label: string, labelMap: any) => {
  if (!label) return;
  
  const lastUnderscoreIndex = label.lastIndexOf('_');
  if (lastUnderscoreIndex !== -1) {
    labelMap[label] = 1;
  }
 
};

export const latexCover = (node, useType: string = 'Code') => {
  return {
    type: "codeBlock",
    attrs: {
      language: node.language || "text",
      id: node.id,
      useType,
      fileName: node.fileName,
      label: node.label || "",
    },
    // 避免空文本节点：当 latex 为空时不生成 text 子节点
    content: node.latex && node.latex.length > 0
      ? [
          {
            type: "text",
            text: node.latex,
          },
        ]
      : [],
  }
}

export const uploadLatexCover = (node, useType: string = 'TableFigure') => {
  return {
    type: "imageCode",
    attrs: {
      src: node.img_url,
      title: node.caption,
      id: node.id,
      level: node.level,
      label: node.label || "",
    },
    content: [
      {
        type: "codeBlock",
        attrs: {
          language: "latex",
          useType: useType,
          fileName: node.file_name,
          id: null
        },
        content: [
          {
            type: "text",
            text: node.latex || "&nbsp;"
          }
        ]
      }
    ]

  }
}

// 处理list
export const listFormatFn = (type, node, parentNode, processInlineContent, generateId, processNodeFn?) => {
  const id = node.attrs?.id || generateId()
    const listNode = {
      id,
      type,
      level: 2,
      parentId: parentNode.id,
      content: "",
      children: [],
    };

    // 处理每个列表项
    node?.content?.forEach((item) => {
      if (item.type === "listItem" && item.content) {
        // 为每个列表项创建一个容器节点
        const listItemNode = {
          id: item.attrs?.id || generateId(),
          type: "paragraph",
          level: 3,
          parentId: id,
          content: "",
          children: [],
        };

        // 处理列表项中的每个元素
        let firstParagraphProcessed = false;
        item.content.forEach((contentItem) => {
          if (contentItem.type === "paragraph") {
            if (!firstParagraphProcessed) {
              // 第一个段落作为列表项的主要内容
              if (contentItem.content) {
                processInlineContent(contentItem.content, listItemNode);
              }
              firstParagraphProcessed = true;
            } else {
              // 后续段落作为子节点保存（删除bullet后的行）
              const extraParagraphNode: any = {
                id: contentItem.attrs?.id || generateId(),
                type: "paragraph",
                level: listItemNode.level + 1,
                parentId: listItemNode.id,
                content: "",
                children: [],
              };
              if (contentItem.content) {
                processInlineContent(contentItem.content, extraParagraphNode);
              }
              listItemNode.children.push(extraParagraphNode);
            }
          } else if (contentItem.type === "bulletList" || contentItem.type === "orderedList") {
            // 处理嵌套列表
            const nestedListType = contentItem.type === "bulletList" ? "ul" : "ol";
            const nestedListNode = listFormatFn(nestedListType, contentItem, listItemNode, processInlineContent, generateId, processNodeFn);
            if (nestedListNode) {
              listItemNode.children.push(nestedListNode);
            }
          } else if (processNodeFn) {
            // 处理其他类型的节点（如图片、代码块、公式、表格等）
            const processedChild = processNodeFn(contentItem, listItemNode, listItemNode.level);
            if (processedChild) {
              listItemNode.children.push(processedChild);
            }
          } else {
            // 处理其他类型的节点（如图片、代码块等）
            // 这里可以根据需要添加其他类型的处理
            // console.log(`Unhandled content type in list: ${contentItem.type}`);
          }
        });
        listNode.children.push(listItemNode);
      } else {
        listNode.children.push({
            id: item.attrs?.id || generateId(),
            type: "paragraph",
            level: 3,
            parentId: id,
            content: "",
            children: [],
          });
      }
    });

    return listNode;
}

export const getUrlPaperId = (): string => {
  const arr: string[] =  window.location.href?.split('/')    
  return arr[arr.length - 1]
}

// 首字母大写工具函数
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

// 支付方式数组
export const paymentMethods = [
  {
    id: "credit",
    name: "Credit Card",
    icon: "/static/payment/credit-card.svg",
  },
  {
    id: "paypal",
    name: "Paypal",
    icon: "/static/payment/paypal.svg",
  },
];

// 缩放选项
export const zoomOptions = [
  { label: 'Fit', value: '100%' },
  { label: '50%', value: '50%' },
  { label: '75%', value: '75%' },
  { label: '90%', value: '90%' },
  { label: '100%', value: '100%' },
  { label: '125%', value: '125%' },
  { label: '150%', value: '150%' },
  { label: '175%', value: '175%' },
  { label: '200%', value: '200%' },
];

// 取消订阅原因数组
export const cancelReasons = [
  { id: "lack_updates", label: "Lack of Updates" },
  { id: "unresolved_bugs", label: "Unresolved Product Bugs" },
  { id: "unmet_value", label: "Unmet Value" },
  { id: "better_alternatives", label: "Better Alternatives" },
  { id: "high_costs", label: "High Costs" },
  { id: "others", label: "Others" },
];


export const pricingPlans = [
  {
    label: "Weekly",
    value: "weekly",
    price: "9.99",
    period: "Week",
    planType: "weekly",
    desc: [
      "pricing-plan-desc-1",
      "pricing-plan-desc-2",
      "pricing-plan-desc-3",
      "pricing-plan-desc-4",
      "pricing-plan-desc-5",
      "pricing-plan-desc-6",
      "pricing-plan-desc-7",
    ],
  },
  {
    label: "Monthly",
    value: "monthly",
    price: "19.99",
    period: "Month",
    planType: "monthly",
    desc: [
      "pricing-plan-desc-1",
      "pricing-plan-desc-2",
      "pricing-plan-desc-3",
      "pricing-plan-desc-4",
      "pricing-plan-desc-5",
      "pricing-plan-desc-6",
      "pricing-plan-desc-7",
    ],
  },
  {
    label: "Annually",
    value: "yearly",
    price: "199.99",
    period: "Year",
    planType: "yearly",
    desc: [
      "pricing-plan-desc-1",
      "pricing-plan-desc-2",
      "pricing-plan-desc-3",
      "pricing-plan-desc-4",
      "pricing-plan-desc-5",
      "pricing-plan-desc-6",
      "pricing-plan-desc-7",
    ],
  },
];


export const priceDesc = ['pricing-plan-desc-1', 'pricing-plan-desc-2', 'pricing-plan-desc-3', 'pricing-plan-desc-4', 'pricing-plan-desc-5', 'pricing-plan-desc-6', 'pricing-plan-desc-7']

export const freePlanDesc = ['free-plan-desc-1', 'free-plan-desc-2', 'free-plan-desc-3', 'free-plan-desc-4', 'free-plan-desc-5', 'free-plan-desc-6']


export const dedupeIds = (outline: PaperOutline) => {
  if (!outline?.nodes?.length) {
    return { outline, nextId: outline?.nextId ?? 0 };
  }

  const seen = new Set<number>();
  let nextIdLocal = typeof outline.nextId === 'number' ? outline.nextId : 0;

  const getMaxId = (nodes: any[]): number => {
    let max = 0;
    nodes.forEach((n: any) => {
      if (typeof n?.id === 'number' && n.id > max) max = n.id;
      if (Array.isArray(n?.children) && n.children.length) {
        const childMax = getMaxId(n.children);
        if (childMax > max) max = childMax;
      }
    });
    return max;
  };

  const initialMax = getMaxId(outline.nodes);
  nextIdLocal = Math.max(nextIdLocal, initialMax);

  const dedupeNode = (node: any, parentId?: number): any => {
    let updated = node;
    if (seen.has(node.id)) {
      nextIdLocal += 1;
      updated = { ...node, id: nextIdLocal };
    } else {
      seen.add(node.id);
    }

    if (typeof updated.parentId === 'number' && typeof parentId === 'number' && updated.parentId !== parentId) {
      updated = { ...updated, parentId };
    }

    if (Array.isArray(updated.children) && updated.children.length) {
      const children = updated.children.map((child: any) => dedupeNode(child, updated.id));
      updated = { ...updated, children };
    }
    return updated;
  };

  const updatedNodes = outline.nodes.map((n: any) => dedupeNode(n));

  const maxIdAfter = getMaxId(updatedNodes);
  const nextIdReturn = (typeof maxIdAfter === 'number' ? maxIdAfter : nextIdLocal) + 1;

  return {
    outline: { ...outline, nodes: updatedNodes, nextId: nextIdReturn },
    nextId: nextIdReturn
  };
}
